import { setListenersFromSelector } from '../functions/listeners';
import { querySelectorAll } from '../functions/querySelectors';

const VIDEO_CLASS = 'js-video';
const VIDEO_INIT_CLASS = 'jv-init';
const VIDEO_CLICKED_CLASS = 'js-video-click';
const VIDEO_WITH_IFRAME_CLASS = 'c-youtube-video--with-iframe';
const VIDEO_ID_ATTR = 'data-video-id';
const VIDEO_WRAP_CLASS = 'c-youtube-video__iframe-wrapper';

let apiAppend = false;

let loadYT = function() {
  apiAppend = true;

  // Load the IFrame Player API code asynchronously.
  let tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/player_api';
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.onYouTubePlayerAPIReady = function() {
    apiReady();
  };
};

let onPlayerReady = function(event) {
  event.target.playVideo();
};

let apiReady = function() {
  let items = querySelectorAll(`.${VIDEO_CLICKED_CLASS}`);

  items.forEach((item) => {
    item.classList.remove(VIDEO_CLICKED_CLASS);
    let videoWrap = item.parentNode;
    let YTid = item.getAttribute(VIDEO_ID_ATTR);

    let iframe = document.createElement('div');
    let iframeInner = document.createElement('div');
    iframe.classList.add(VIDEO_WRAP_CLASS);
    iframe.appendChild(iframeInner);
    videoWrap.appendChild(iframe);
    videoWrap.classList.add(VIDEO_WITH_IFRAME_CLASS);

    loadVideo(iframeInner, YTid);
  });
};

let loadVideo = function(element, YTid) {
  // eslint-disable-next-line
  let player = new YT.Player(element, {
    height: '360',
    width: '640',
    videoId: YTid,
    events: {
      'onReady': onPlayerReady
    }
  });
};

let videoClick = function(event) {
  event.preventDefault();

  this.classList.add(VIDEO_CLICKED_CLASS);

  if (!apiAppend) {
    loadYT();
  }
  else if (typeof YT !== 'undefined') {
    apiReady();
  }
};

export function youtubeVideo() {
  setListenersFromSelector(
    `.${VIDEO_CLASS}`,
    VIDEO_INIT_CLASS,
    videoClick
  );
};
